import { render, staticRenderFns } from "./GoLive.vue?vue&type=template&id=126f3644&"
import script from "./GoLive.vue?vue&type=script&lang=js&"
export * from "./GoLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports